import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { PERSIST, persistStore, PURGE } from 'redux-persist';
import { createStateSyncMiddleware, initStateWithPrevTab } from 'redux-state-sync';
import thunk from 'redux-thunk';

import { ISupportUserService } from '@/services/types/SupportUserService.types';
import { toasterMiddleware } from '@/store/middlewares/toasterMiddleware';
import { cryptoMiddleware } from '@/store/middlewares/cryptoMiddleware';

import { getReducersHandlers, persistedReducer } from './reducers/reducers';

export const routeStore: { supportUserPassphrase?: string } = {};

export interface IDependencies {
  supportUserService: ISupportUserService;
}

const middleware = [
  // jwt,
  thunk,
  toasterMiddleware,
  cryptoMiddleware,
  createStateSyncMiddleware({
    // List all Redux actions to disable syn between tabs
    blacklist: [
      ...getReducersHandlers([
        'modal',
        'profile',
        'payout',
        'template',
        'p2p',
        'bulkCardCreation',
        'search',
        'searchHistory',
        'router',
      ]),
      PERSIST,
      PURGE,
    ],
  }),
];

const middlewareEnhancer = applyMiddleware(...middleware);

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
export const store = createStore(persistedReducer, composeEnhancers(middlewareEnhancer));
initStateWithPrevTab(store);

export type TAppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

export type TStoreAsyncAction = {
  types: string[];
  promise: () => Promise<any>;
  params?: any;
};

export type TStoreSyncAction = {
  type: string;
  params?: any;
};

export type TStoreAction = TStoreAsyncAction | TStoreSyncAction;

(window as any).store = store;
